import {Redirect, useHistory, useParams} from 'react-router';
import {useAuth} from 'context/auth-context';
import {PATH} from 'constants/common';
import {createOnboardingUrlPath} from 'components/pages/OnboardingPage/onboardingSteps';
import {StepTypes} from 'types/onboarding';
import AmnisButton from 'components/ui/AmnisButton/AmnisButton';
import styles from './JumioPage.module.scss';

type JumioStatus = 'success' | 'error';

const STATUS_TEXTS: Record<JumioStatus, {title: string; description: string}> =
    {
        success: {
            title: 'Identification submitted!',
            description:
                'You can now switch to your desktop to complete the process.',
        },
        error: {
            title: 'We couldn’t verify your identity.',
            description:
                'Please restart the process on your desktop. A new link will be sent to your mobile phone.',
        },
    };

const JumioRedirectPage = () => {
    const {status} = useParams<{status: JumioStatus}>();
    const {user} = useAuth();
    const history = useHistory();

    if (user) {
        return <Redirect to={createOnboardingUrlPath(StepTypes.IDENTITY)} />;
    }

    return (
        <div className={styles.container}>
            <h3>{STATUS_TEXTS[status].title}</h3>
            <p>{STATUS_TEXTS[status].description}</p>
            <AmnisButton
                endIcon="arrowOutward"
                onClick={() =>
                    history.push(createOnboardingUrlPath(StepTypes.IDENTITY))
                }
            >
                Login
            </AmnisButton>
        </div>
    );
};

export default JumioRedirectPage;
